/**
 * Service de la page Pointeuse
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const pointeuseService = {
  getState: () => api.get(endpoints.pointeuse.etat()),

  refresh: () => api.post(endpoints.pointeuse.actualiser(), {}),

  getPeriod: (range) => api.get(endpoints.pointeuse.periode(range)),

  getCounter: (range) => api.get(endpoints.pointeuse.compteur(range)),

  exportPayroll: (params) => api.get(endpoints.pointeuse.exportPaie(params), { responseType: 'blob' }),

  getToTreat: () => api.get(endpoints.pointeuse.aTraiter()),

  getSalaries: () => api.get(endpoints.pointeuse.salaries()),

  saveSalarie: (salarieId, fiche) => api.put(endpoints.pointeuse.salarie(salarieId), fiche),

  saveSettings: (parametres) => api.put(endpoints.pointeuse.parametres(), parametres),

  getToTreatCount: () => api.get(endpoints.pointeuse.aTraiterCompte()),

  remind: ({ salarieId, jours }) => api.post(endpoints.pointeuse.relancer(), { salarieId, jours }),

  classify: ({ salarieId, jour, motif }) => api.post(endpoints.pointeuse.classer(), { salarieId, jour, motif }),

  setPlannedPause: (salarieId, minutes) => api.put(endpoints.pointeuse.pausePrevue(salarieId), { minutes })
}
